import * as CONSTANTS from './constants'
import { addRemoveArrayOperation } from '../../Common/utils'
import { getDefaultPrimaryFilterInfo } from './../utils'

export const getInitialState = () => {
  return {
    dataLoading: true,
    data: {},
    filters: {
      boardingPoints: {},
      droppingPoints: {},
      operators: {},
      amenities: {},
      collapsedFilter: ['boardingPoint', 'droppingPoint', 'operator', 'amenities'],
      collapsedFilterItemCount: 3,
      activeSearch: { type: '', val: '' },
      popularFilters: []
    },
    rawData: {},
    privateAvailableBuses: {},
    privateSoldOutBuses: {},
    rtcBuses: {},
    sortBy: 'best',
    rtcView: '',
    routeId: '',
    goSafeData: {},
    primaryFiltersInfo: getDefaultPrimaryFilterInfo(),
    isOTGApplicable: false,
    isGosafe: false,
    isLiveTracking: false,
    isRedDeal: false,
    dumpData: false,
    bpdpData: {},
    otherPrivateAvailableBuses: {},
    otherRTCBuses: {},
    leaveIntentData: []
  };
}

//TODO:- returning a new object each time with Object.assign instead of direct state manipulation
export default function RoutePage(state = getInitialState(), action) {
  const { type, actionData } = action;
  let filters = Object.assign({}, state.filters);

  switch (type) {
    case CONSTANTS.UPDATE_ROUTE_DATA:
      return Object.assign({}, state, {
        ...state,
        data: actionData.data,
        dataLoading: false
      })
    case CONSTANTS.FILTER_COLLAPSE:
      filters.collapsedFilter = addRemoveArrayOperation([...state.filters.collapsedFilter], actionData);
      return Object.assign({}, state, {
        ...state,
        filters: filters
      })
    case CONSTANTS.UPDATE_SRP_BUS_DATA:
      filters.boardingPoints = actionData.bpList;
      filters.droppingPoints = actionData.dpList;
      filters.operators = actionData.operatorsList;
      filters.amenities = actionData.amenities;
      filters.popularFilters = actionData.popularFilters

      return Object.assign({}, state, {
        ...state,
        rawData: actionData.data,
        privateAvailableBuses: actionData.privateAvailableBuses,
        rtcBuses: actionData.rtcBuses,
        filters: filters,
        primaryFiltersInfo: actionData.primaryFiltersInfo || getDefaultPrimaryFilterInfo(),
        isOTGApplicable: actionData.isOTGApplicable || false,
        isGosafe: actionData.isGosafe || false,
        isLiveTracking: actionData.isLiveTracking || false,
        isRedDeal: actionData.isRedDeal || false,
        dumpData: actionData.dumpData || state.dumpData,
        bpdpData: actionData.bpdpData || state.bpdpData,
        otherPrivateAvailableBuses: actionData.otherPrivateAvailableBuses || state.otherPrivateAvailableBuses,
        otherRTCBuses: actionData.otherRTCBuses || state.otherRTCBuses


      })
    case CONSTANTS.UPDATE_GO_SAFE_BANNER:
      return Object.assign({}, {
        ...state,
        goSafeData: actionData.data
      })
    case CONSTANTS.UPDATE_ROUTE_ID:
      return Object.assign({}, {
        ...state,
        routeId: actionData
      })
    case CONSTANTS.STORE_LEAVE_INTENT_DATA:
      return Object.assign({}, {
        ...state,
        leaveIntentData: actionData
      })
    default:
      return state;
  }
}


